import Users from './Personnel';

export default {
  priority: 11,
  path: 'user',
  permissions: ['ShiftAssignment'],
  // component: Users,
  component: load(() => import(/* webpackChunkName: "Setting-Users" */ './Personnel')),
  name: app.translate('پرسنل'),
  icon: 'account-check',
  drawer: true,
};


